import { createFileRoute } from "@tanstack/react-router";
import { permissionMatrixSearchSchema } from "@/lib/search/permission-matrix-search";

const WorkspaceSettingsWorkinghoursRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/workspace/workinghours/")({
	validateSearch: permissionMatrixSearchSchema,
	component: WorkspaceSettingsWorkinghoursRoute,
});
